import * as moment from "moment";

import { Link, TaskModel } from "@teamprevent/common/task/taskActions/models";

export const CaseConversationTask = "CaseConversationTask";

export enum MessageType {
    CaseMessage = "CaseMessage",
    NoReplyRequired = "NoReplyRequired"
}

export interface Message {
    subject: string;
    message: string;
    createdBy: Link;
    dateCreated: moment.Moment;
    caseMessageType: string;
    documents: MessagingDocument[];
}

export interface MessageReply extends Message {
    noReplyRequired: boolean;
}

export interface MessageDetails {
    subject: string;
    messages: Message[];
    subjectStartDate: moment.Moment;
}

export interface ReplyCaseConversationModel {
    messageDetails: MessageDetails;
    taskDetails: TaskModel;
}

export interface MessageState {
    readonly messages: MessageDetails[];
}

export interface MessagingDocument {
    blobId: string;
    fileName: string;
    dateCreated: moment.Moment;
}

export const message: Message = {
    subject: "",
    message: "",
    dateCreated: moment().utc(),
    createdBy: {
        id: "",
        name: ""
    },
    caseMessageType: "",
    documents: []
};

export const messageReply: MessageReply = {
    ...message,
    noReplyRequired: false
};

export interface CaseConversationTaskModel extends TaskModel {
    readonly caseSubject: string;
}

export const isCaseConversationTask = (task: TaskModel): task is CaseConversationTaskModel => {
    return !!(task as CaseConversationTaskModel).caseSubject;
};

export type AppState = MessageState & { router: Location };
